var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearCache(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3699 4.89L13.5099 2.28C12.6499 1.9 11.3499 1.9 10.4899 2.28L4.62993 4.89C3.14993 5.55 2.92993 6.45 2.92993 6.93C2.92993 7.41 3.14993 8.31 4.62993 8.97L10.4899 11.58C10.9199 11.77 11.4599 11.87 11.9999 11.87C12.5399 11.87 13.0799 11.77 13.5099 11.58L19.3699 8.97C20.8499 8.31 21.0699 7.41 21.0699 6.93C21.0699 6.45 20.8599 5.55 19.3699 4.89Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 17.04C11.6201 17.04 11.2401 16.96 10.8901 16.81L4.15007 13.81C3.12007 13.35 2.32007 12.12 2.32007 10.99C2.32007 10.58 2.65007 10.25 3.06007 10.25C3.47007 10.25 3.80007 10.58 3.80007 10.99C3.80007 11.53 4.25007 12.23 4.75007 12.45L11.4901 15.45C11.8101 15.59 12.1801 15.59 12.5001 15.45L19.2401 12.45C19.7401 12.23 20.1901 11.54 20.1901 10.99C20.1901 10.58 20.5201 10.25 20.9301 10.25C21.3401 10.25 21.6701 10.58 21.6701 10.99C21.6701 12.11 20.8701 13.35 19.8401 13.81L13.1001 16.81C12.7601 16.96 12.3801 17.04 12.0001 17.04Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22C11.6201 22 11.2401 21.92 10.8901 21.77L4.15007 18.77C3.04007 18.28 2.32007 17.17 2.32007 15.95C2.32007 15.54 2.65007 15.21 3.06007 15.21C3.47007 15.21 3.80007 15.54 3.80007 15.95C3.80007 16.58 4.17007 17.15 4.75007 17.41L11.4901 20.41C11.8101 20.55 12.1801 20.55 12.5001 20.41L19.2401 17.41C19.8101 17.16 20.1901 16.58 20.1901 15.95C20.1901 15.54 20.5201 15.21 20.9301 15.21C21.3401 15.21 21.6701 15.54 21.6701 15.95C21.6701 17.17 20.9501 18.27 19.8401 18.77L13.1001 21.77C12.7601 21.92 12.3801 22 12.0001 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCache);
export default __webpack_public_path__ + "static/media/clear-cache.d6447f238f119abe2775cdbc2392c36e.svg";
export { ForwardRef as ReactComponent };